import { render } from "./OpenFolder.vue?vue&type=template&id=f311cd4a&bindings={}"
import script from "./OpenFolder.vue?vue&type=script&lang=js"
export * from "./OpenFolder.vue?vue&type=script&lang=js"
script.render = render

export default script